<template>
  <div>
    <div class="index" v-show="!detail.show">
      <div class="title">
        <div class="span1">
          <span>{{$route.name}}</span>
        </div>
        <p style="color:#606266;font-size:14px;">样例</p>
      </div>

      <header>
        <div class="header-item">
          <div class="header-item-title">
            <span class="circle"></span>
            <span>课程评价统计</span>
          </div>
          <div id="echarts-box1"></div>
        </div>

        <div class="header-item">
          <div class="header-item-title">
            <span class="circle"></span>
            <span>好评课程TOP5</span>
          </div>
           <p class="header-item-text">好评人数=评价四星人数+评价五星人数</p>
          <div id="echarts-box2"></div>
        </div>
      </header>

      <div>
        <div class="table">
          <el-table :data="tableData" style="width: 100%">
            <el-table-column prop="className" label="班级名称" align="center">
            </el-table-column>
            <el-table-column
              prop="classStudentNum"
              label="授课教师"
              align="center"
            >
            </el-table-column>
            <el-table-column prop="signNum" label="课程分类" align="center">
            </el-table-column>
            <el-table-column
              prop="needAttendanceNum"
              label="课程分类"
              align="center"
            >
            </el-table-column>
            <el-table-column prop="lateNum" label="招生年级" align="center">
            </el-table-column>
            <el-table-column prop="leaveNum" label="实际出勤人次" align="center">
            </el-table-column>
            <el-table-column
              prop="leaveNum"
              label="评价人次"
              align="center"
            >
            </el-table-column>
            <el-table-column
              prop="leaveNum"
              label="好评数"
              align="center"
            >
            </el-table-column>
            <el-table-column
              prop="attendanceNum"
              label="好评率"
              align="center"
            >
            </el-table-column>
            <el-table-column
              header-align="center"
              align="center"
              label="操作"
              width="200"
              fixed="right"
            >
              <template slot-scope="scope">
                <el-button type="text" size="small" @click="toDetail(scope.row)"
                  >查看详情</el-button
                >
              </template>
            </el-table-column>
          </el-table>
          <div class="pagination">
            <el-pagination
              background
              :current-page="pageNum"
              :page-sizes="[10, 20, 50, 100]"
              :page-size="pageSize"
              :total="totalPage"
              layout="total,prev, pager, next,jumper,sizes"
              @size-change="sizeChangeHandle"
              @current-change="currentChangeHandle"
            ></el-pagination>
          </div>
        </div>
      </div>
    </div>
    <Detail
      :info="detail.info"
      v-show="detail.show"
      @to-index="toIndex"
    ></Detail>
  </div>
</template>
<script>
import api from "@/api/wisdomSchool/index.js";
import dayjs from "dayjs";
import * as echarts from "echarts";
export default {
  components: {
    Detail: () => import("./detail.vue"),
  },
  data() {
    return {
      pageNum: 1,
      pageSize: 10,
      totalPage: 10,
      queryParams: {
        semester: "",
        source: "",
        teacher: "",
        name: "",
      },
      sourceList: [],
      semesterList: [],
      teacherList: [],
      tableData: [ 
          {className:'科技编程',    classStudentNum: "庄萍雅",  signNum: "兴趣小组",needAttendanceNum: "三年级",lateNum: '34',leaveNum: '30', attendanceNum: '93.33%'},
           {className:'酷酷机器人',  classStudentNum: "杨萍蓓",  signNum: "社团活动",needAttendanceNum: "四年级",lateNum: '36',leaveNum: '30', attendanceNum: '93.33%'},
           {className:'幸福劳动',    classStudentNum: "严姣婷",  signNum: "劳动	   ",needAttendanceNum: "一年级",lateNum: '30',leaveNum: '28', attendanceNum: '92.86%'},
           {className:'博学书法',    classStudentNum: "昌琦嘉",  signNum: "文体	   ",needAttendanceNum: "三年级",lateNum: '26',leaveNum: '24', attendanceNum: '91.67%'},
           {className:'美学鉴赏课',  classStudentNum: "奚秋叶",  signNum: "艺术	   ",needAttendanceNum: "二年级",lateNum: '38',leaveNum: '35', attendanceNum: '91.43%'},
           {className:'温暖美术',    classStudentNum: "强希礼",  signNum: "艺术	   ",needAttendanceNum: "四年级",lateNum: '42',leaveNum: '40', attendanceNum: '90.00%'},
           {className:'世界百科课',  classStudentNum: "明环凯",  signNum: "科普	   ",needAttendanceNum: "三年级",lateNum: '16',leaveNum: '20', attendanceNum: '90.00%'},
           {className:'海滨少儿美术',classStudentNum: "闫媛娣",  signNum: "艺术	   ",needAttendanceNum: "五年级",lateNum: '18',leaveNum: '16', attendanceNum: '87.50%'},
           {className:'竞技篮球',    classStudentNum: "习华伊",  signNum: "文体	   ",needAttendanceNum: "三年级",lateNum: '40',leaveNum: '38', attendanceNum: '86.84%'},
           {className:'优美声乐',    classStudentNum: "寿歌姣",  signNum: "文体	   ",needAttendanceNum: "二年级",lateNum: '33',leaveNum: '30', attendanceNum: '86.67%'},
           ],
      detail: {
        info: {},
        show: false,
      },
      school_info: JSON.parse(sessionStorage.getItem("classList")),
      semesterArr: JSON.parse(sessionStorage.getItem("semesterList")),
    };
  },
  watch: {
    "queryParams.source": function (n, o) {
      this.queryParams.teacher = "";
      this.teacherList = [];
      // this.gradeList = this.campusList.filter((v) => v.id === n)[0]?.children || [];
    },
  },
  mounted() {
    // this.semesterList = this.semesterArr.map((v) => ({
    //   label: v.schoolYear + "第" + v.semester + "学期",
    //   id: v.schoolYear + "_" + v.semester,
    // }));
    // this.getDataList();
    this.init();
  },
  created() {
    // this.campusList = this.school_info?.slice() || [];
  },
  methods: {
    async getDataList() {
      let start = "",
        end = "";
      let params = {
        schoolYearSemester: this.queryParams.semester,
        startDate: start,
        endDate: end,
        campusId:this.queryParams.campus,
        gradeId: this.queryParams.grade,
        classId: this.queryParams.class,
        orgId: sessionStorage.getItem("orgId"),
        platformCode: sessionStorage.getItem("platformCode"),
        page: this.pageNum,
        limit: this.pageSize,
      };
      this.tableData=[  
          ]
           
    },
    searchFun() {
      this.pageNum = 1;
      this.getDataList();
    },
    sizeChangeHandle(val) {
      this.pageSize = val;
      this.getDataList();
    },
    currentChangeHandle(val) {
      this.pageNum = val;
      this.getDataList();
    },
    toDetail(item) {
      this.detail.info = item;
      this.detail.show = true;
    },
    toIndex() {
      this.detail.show = false;
    },
    init(){
      let vm = this;
      this.$nextTick(() => {
        // 圆环图
        let chartDom1 = document.getElementById('echarts-box1');
        let myChart = echarts.init(chartDom1);
        let option = {
          legend: {
            // data: [],
            // orient: 'vertical',
            left: 'center',
            top: 'bottom',
            icon : 'circle',
          },
          series: [
            {
              name: '',
              type: 'pie',
              radius: ['38%', '50%'], // 这个属性修改环形宽度
              avoidLabelOverlap: false,
              itemStyle: {
                borderRadius: 0,
                borderColor: '#fff',
                borderWidth: 0,
              },
              label: {
                show: false,
                position: 'center',
              },
              emphasis: {
                label: {
                  show: false,
                  fontSize: '16',
                  fontWeight: 'bold',
                },
              },
              labelLine: {
                show: false,
              },
              data: [
                { value: 60, name: '5星' },
                { value: 58, name: '4星' },
                { value: 32, name: '3星' },
                { value: 30, name: '2星' },
                { value: 28, name: '1星' },
              ],
            },
          ],
          // 圆环颜色
          color: ['#5BB0FF', '#51D6A6', '#EFD051', '#F27676', '#757FFD'],
        };
        myChart.setOption(option);

        // 柱状图
        let chartDom2 = document.getElementById('echarts-box2');
        let myChart2 = echarts.init(chartDom2);
        let option2 = {
          tooltip: {
            trigger: 'item',
            backgroundColor: 'rgba(0, 0, 0, .6)', //通过设置rgba调节背景颜色与透明度
            borderWidth: '0',
            textStyle: {
              color: 'white',
              fontSize: '12',
            },
            formatter: function (params, ticket, callback) {
              return "<span style='font-size: 26px;line-height: 30px;'>" + params.value + '</span>' + '<br />' + "<span style='font-size:14px;line-height: 18px;'>" + params.name + '</span>';
            },
          },
          grid: {
            height: 200,
            top: 30,
            left: 42,
          },
          xAxis: {
            type: 'category',
            data: ['自主作业', '班级校级\n社团课', '经典诵读', '自主作业', '经典诵读'],
            // splitLine: {show: false},//去除网格分割线
            axisLine: {
              //坐标线
              lineStyle: {
                type: 'solid',
                color: '#DDDDDD', //轴线的颜色
                width: '1', //坐标线的宽度
              },
            },
            axisLabel: {
              textStyle: {
                color: '#999999', //坐标值的具体的颜色
              },
            },
          },
          yAxis: {
            type: 'value',
          },
          series: [
            {
              data: [10, 10, 8, 6, 5],
              type: 'bar',
              showBackground: true,
              backgroundStyle: {
                // 背景颜色
                color: 'none', //'#E8F6FF'
              },
              itemStyle: {
                // 柱子颜色
                normal: {
                  color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
                    // { offset: 0, color: '#009DFD' },
                    { offset: 1, color: '#5BB0FF' },
                  ]),
                  // barBorderRadius: 16, // 柱子圆角, 单位为px
                },
              },
              barWidth: 20, //设置柱子宽度，单位为px
            },
          ],
        };
        myChart2.setOption(option2);

        // 柱状图
        let chartDom3 = document.getElementById('echarts-box3');
        let myChart3 = echarts.init(chartDom3);
        let option3 = {
          tooltip: {
            trigger: 'item',
            backgroundColor: 'rgba(0, 0, 0, .6)', //通过设置rgba调节背景颜色与透明度
            borderWidth: '0',
            textStyle: {
              color: 'white',
              fontSize: '12',
            },
            formatter: function (params, ticket, callback) {
              return "<span style='font-size: 26px;line-height: 30px;'>" + params.value + '</span>' + '<br />' + "<span style='font-size:14px;line-height: 18px;'>" + params.name + '</span>';
            },
          },
          grid: {
            height: 200,
            top: 30,
            left: 42,
          },
          xAxis: {
            type: 'category',
            data: ['课程1', '课程1', '课程1', '课程1', '课程1'],
            axisLine: {
              //坐标线
              lineStyle: {
                type: 'solid',
                color: '#DDDDDD', //轴线的颜色
                width: '1', //坐标线的宽度
              },
            },
            axisLabel: {
              textStyle: {
                color: '#999999', //坐标值的具体的颜色
              },
            },
          },
          yAxis: {
            type: 'value',
          },
          series: [
            {
              data: [110, 210, 256, 146, 388],
              type: 'bar',
              showBackground: true,
              backgroundStyle: {
                // 背景颜色
                color: 'none', //'#E8F6FF'
              },
              itemStyle: {
                // 柱子颜色
                normal: {
                  color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
                    { offset: 1, color: '#51D6A6' },
                  ]),
                },
              },
              barWidth: 20, //设置柱子宽度，单位为px
            },
          ],
        };
        myChart3.setOption(option3);
      });
    },
  },
};
</script>
<style lang="less" scoped>
.index {
  width: 100%;
  padding: 0px 30px 30px 30px;
  .title {
    height: 60px;
    line-height: 48px;
    border-bottom: 1px solid #eaeaea;
    margin-bottom: 20px;
    display: flex;
    justify-content: space-between;
    .span1 {
      font-family: "PingFang SC Bold";
      font-weight: bold;
      font-size: 20px;
      text-align: left;
      color: #000;
      margin-right: 30px;
    }
  }

  ::v-deep .el-form .el-input__inner {
    // width: 150px;
    height: 32px;
    border-radius: 3px;
    background: #fff;
    border: 1px solid #ddd;
  }

  ::v-deep .el-table__header tr th {
    background: #f7f7f7;
    box-shadow: 0px 1px 0px #eaeaea;
  }

  ::v-deep .el-date-editor .el-range-separator {
    line-height: 22px;
  }

  .pagination {
    text-align: center;
    margin-top: 30px;
  }
}
header{
  width: 100%;
  height: 350px;
  display: flex;
  .header-item{
    width: 48%;
    .header-item-title{
      font-size: 18px;
      color: #333;
      display: flex;
      align-items: center;
      .circle{
        width: 8px;
        height: 8px;
        display: inline-block;
        background: #4991e1;
        border-radius: 50%;
        margin-right: 10px;
      }
    }
    .header-item-text{
      font-size: 14px;
      color: #666;
      padding-left: 20px;
      margin-top: 5px;
    }
  }
  #echarts-box1{
    width:380px;
    height:280px;
  }
  #echarts-box2,#echarts-box3{
    width:500px;
    height:280px;
  }
  #echarts-box3{
    margin-top: 25px;
  }
}
</style>
